<template>
    <div>
        <div class="flex justify-between items-center mb-3">
            <h2 class="text-xl text-gray-800">Projects</h2>
            <AddProfileProject @added="fetchProjects" />
        </div>
        <div v-if="projects.length > 0" class="bg-white shadow-lg rounded-lg border border-gray-300">
            <Draggable tag="div" :list="projects" handle=".handle" @end="onDragCompleted">
                <ListItem v-for="project in projects" :key="project.id" :item-key="project.id" @delete="removeRecord">
                    <div class="flex flex-col">
                        <h3 class="text-sm sm:text-xl font-semibold">{{ project.title }}</h3>
                        <p class="mt-2 text-gray-700" v-html="project.description"></p>
                    </div>

                    <template v-slot:edit-component>
                        <EditComponent
                            model="project"
                            :modal-title="project.title"
                            :record="project"
                            class="mr-1 sm:mr-3 text-sm"
                            @updated="fetchProjects"
                        />
                    </template>
                </ListItem>
            </Draggable>
        </div>
        <div v-else>
            <p class="py-4 text-center w-full text-sm text-gray-500 border-t border-gray-300">
                {{ placeholder }}
            </p>
        </div>
    </div>
</template>

<script>
import ListItem from '../EditList/ListItem';
import AddProfileProject from './AddProfileProject';

const Draggable = () => import(/* webpackChunkName: "lazy-loaded/vuedraggable" */ 'vuedraggable');

export default {
    components: { AddProfileProject, Draggable, ListItem },

    data() {
        return {
            projects: [],
            placeholder: 'Loading...'
        };
    },

    watch: {
        projects: function(newVal) {
            if (newVal.length < 1) {
                this.placeholder = 'There is no project on your list';
            }
        }
    },

    mounted() {
        this.fetchProjects();
    },

    methods: {
        fetchProjects() {
            axios.get(`/api/profile-projects`).then(response => {
                this.projects = response.data.data;
            });
        },

        onDragCompleted() {
            this.updateSorting();
        },

        updateSorting() {
            let newSortedIds = this.projects.map(project => project.id);

            axios
                .post(`/api/profile-projects/sort`, { ids: newSortedIds })
                .then(() => flash.success())
                .catch(() => flash.error());
        },

        removeRecord(recId) {
            if (!confirm('Are you sure to delete this project?')) {
                return;
            }

            axios
                .delete(`/api/profile-projects/${recId}`)
                .then(() => {
                    this.fetchProjects();
                    flash.success();
                })
                .catch(() => {
                    flash.error();
                });
        }
    }
};
</script>
